import { IconBell } from 'featherico';
import { map } from 'lodash/fp';
import PropTypes from 'prop-types';
import { Component } from 'react';
import InfiniteScroll from '../../InfiniteScroll';
import Spinner from '../../Spinner';
import NotificationItem from '../NotificationItem';
import styles from '../NotificationsDropdown/style.m.less';
import ownStyles from './style.m.less';

import classNames from 'classnames';

const propTypes = {
    notifications: PropTypes.arrayOf(PropTypes.object).isRequired,
    isDropdown: PropTypes.bool,
    className: PropTypes.string,
    actions: PropTypes.shape({
        doGetNotifications: PropTypes.func.isRequired,
    }).isRequired,
};

export default class NotificationsList extends Component {
    componentDidMount() {
        if (!this.props.notifications.length) {
            this.props.actions.doGetNotifications();
        }
    }

    render() {
        const { notifications, isLoading, isDropdown, className, actions } = this.props;
        const noNotifications = !notifications.length;
        if (isLoading && noNotifications) {
            return (
                <div className={ownStyles.spinner}>
                    <Spinner />
                </div>
            );
        }

        if (noNotifications) {
            return <div className={ownStyles.empty}>No notifications.</div>;
        }

        const containerClasses = classNames(className, styles.list, { [styles.dropdown]: isDropdown });

        const getMore = noOfItems => {
            const limit = isDropdown ? 20 : 40;
            actions.doGetNotifications({ offset: noOfItems, limit });
        };

        const infiniteScrollProps = {
            items: notifications,
            initialCount: isDropdown ? 10 : 20,
            increment: count => count + 10,
            onItemsDepleted: getMore,
            noToTop: true,
            loader: <Spinner />,
            closer: isDropdown ? null : <NoMoreNotifications />,
            className: isDropdown ? [styles.has_more_content] : null,
        };

        return (
            <InfiniteScroll {...infiniteScrollProps}>
                {items => <InnerList className={containerClasses} items={items} />}
            </InfiniteScroll>
        );
    }
}

function NoMoreNotifications() {
    return (
        <div className={styles.no_more_notifications}>
            <IconBell /> No more notifications
        </div>
    );
}

function InnerList({ items, className }) {
    return (
        <ul className={className}>
            {map(
                item => (
                    <NotificationItem key={item.id} item={item} />
                ),
                items
            )}
        </ul>
    );
}

NotificationsList.propTypes = propTypes;
